<template>
    <div
        class="lb-project-content has-scroll-y px-4" :class="{'embed':embed}"
        @drop.prevent="addFile"
        @dragover.prevent
        @dblclick="enableCreation"
        @scroll.passive="handleDebouncedScroll"
    >
        <div
            :class="{
                'grid-container': projectLayout == 'GRID',
            }"
            class="pb-6 mb-6 mt-3"
        >
            <draggable
                id="grid"
                ref="grid"
                v-model="orderedItems"
                :disabled="dragIsDisabled || draft._id == 'draft'"
                @end="dragEndHandler"
            >
                <div
                    v-for="(item,index) in orderedItems"
                    :key="item._id"
                    :ref="item._id"
                    class="is-invisible"
                >
                    <object-card v-if="!isMemory"
                        :model="contentModel"
                        :content="item"
                        :is-edition="false"
                        :is-creation="false"
                        :modal-opened="modalOpened"
                        :show-answers="showAnswers"

                        :editing="editionEnabled"
                        :canEdit="canEdit"
                        @resize="debouncedRecalculate"
                        
                        @cancel="$emit('cancel')"
                        
                        @addElement="openModal"

                        @edit="enableEdition(item)"
                        @show="$emit('show',item)"
                        @zoomImage="zoomImage"
                        
                    />
                    <object-card-memory v-else
                        :model="contentModel"
                        :content="item"
                        :is-edition="false"
                        :is-creation="false"
                        :modal-opened="modalOpened"
                        :show-answers="showAnswers"
                        :index="index"

                        :editing="editionEnabled"
                        :canEdit="canEdit"
                        @resize="debouncedRecalculate"
                        
                        @cancel="$emit('cancel')"
                        
                        @addElement="openModal"

                        @edit="enableEdition(item)"
                        @show="$emit('show',item)"
                        @zoomImage="zoomImage"
                        
                    />
                </div>
            </draggable>
        </div>
        <project-timeline-navigator
            v-if="loadTimeline"
            :items="orderedItems"
            @click="$emit('click', $event)"
        />
    </div>
</template>

<script>
import ObjectCard from '@/components/ObjectCard';
import draggable from 'vuedraggable';
import Macy from 'macy';
import ProjectTimelineNavigator from '@/components/ProjectTimelineNavigator';
import _ from 'underscore';
import ObjectCardMemory from '@/components/ObjectCardMemory';
export default {
    name: 'ProjectContent',
    components: {
        ObjectCard,
        draggable,
        ProjectTimelineNavigator,
        ObjectCardMemory,
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        draft: {
            type: Object,
            default() {
                return {};
            },
        },
        modalOpened: { type: Boolean, default: false },
        showAnswers: {
            type: Boolean,
            default: false,
        },
        editionEnabled: { type: Boolean, default: false },
        canEdit: { type: Boolean, default: false },
        isViewMode: { type: Boolean, default: false },
    },
    data() {
        return {
            macy: undefined,
            visibleItems: 100,
            drawObserver: new MutationObserver((mutations) => {
                for (let entry of mutations) {
                    if (
                        entry.target.getAttribute('data-macy-complete') &&
                        entry.target.classList.contains('is-invisible')
                    ) {
                        entry.target.classList.remove('is-invisible');
                    }
                }
            }),
            embed: this.$route.meta.embed,
            hideLogin: this.$route.meta.hideLogin,
        };
    },
    computed: {
        isMemory() {
            return this.$store.getters.project.format == "PROJECT_TYPE_MEMORY"
        },
        loadTimeline() {
            return (
                this.projectType == 'storytelling' &&
                this.$store.getters.isAdmin
            );
        },
        projectType() {
            return this.$store.getters.project.type;
        },
        projectConfiguration() {
            if(this.$store.getters.project && this.$store.getters.project.configuration){
                return this.$store.getters.project.configuration.global;
            }
            
        },
        handleDebouncedScroll() {
            return _.debounce(this.handleScroll, 100);
        },
        debouncedRecalculate() {
            return _.debounce(this.recalculate, 100);
        },
        dragIsDisabled() {
            return (
                this.draft._id ||
                (!this.hasEditPermission && !this.hasAdminPermission) ||
                this.$mq == 'mobile' || this.isViewMode
            );
        },
        contentModel() {
            if (this.projectType === 'trivial' || this.projectType === 'quizhunt') {
                return this.$store.getters.questionModel;
            } else {
                return this.$store.getters.objectModel;
            }
        },
        orderedItems: {
            get() {
                return _.chain(this.items)
                    .sortBy((item) => {
                        if (this.projectConfiguration && this.projectConfiguration.order == 'FORWARD') {
                            return item.order;
                        }
                        return -item.order;
                    })

                    .first(this.visibleItems)
                    .value();
            },
            set(items) {
                this.$store.dispatch('updateObjectsOrder', items);
            },
        },
        hasCreationPermission() {
            return this.$store.getters.project.accessLevel != 'read';
        },
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        hasEditPermission() {
            return this.$store.getters.project.accessLevel == 'edit';
        },
        clipboardContent() {
            return this.$store.getters.clipboardContent;
        },
        projectLayout() {
            return this.$store.getters['Project/layout'];
        },
    },
    watch: {
        clipboardContent(content) {
            if (!content) {
                return;
            }
            for (var i = 0; i < content.length; i++) {
                if (content[i].type.indexOf('image') !== -1) {
                    this.$emit('add-element', 'image');
                } else {
                    console.log('not image', content[i].type);
                }
            }
        },
        'items.length': 'debouncedRecalculate',
        projectLayout: 'buildLayout',
    },
    mounted() {
        this.buildLayout();
        this.drawObserver.observe(this.$refs.grid.$el, {
            attributes: true,
            subtree: true,
            attributeOldValue: true,
            attributeFilter: ['data-macy-complete'],
        });
    },
    destroyed() {
        this.drawObserver.disconnect();
    },
    methods: {
        buildLayout() {
            let breakAt, columns;
            if (this.projectLayout != 'VERTICAL') {
                columns = 8;
                breakAt = {
                    1920: 6,
                    1850: 5,
                    1440: 4,
                    1024: 3,
                    768: 2,
                    425: 1,
                };
            } else {
                columns = 1;
                breakAt = {};
            }
            this.macy = Macy({
                container: '#grid',
                margin: 24,
                trueOrder: true,
                columns,
                breakAt,
                useContainerForBreakpoints: true,
            });
        },
        addFile(e) {
            let droppedFiles = e.dataTransfer.files;
            let files = [];
            if (!droppedFiles) return; // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
            [...droppedFiles].forEach((f) => {
                files.push(f);
            });
            this.$store.dispatch('setClipboardContent', files);
        },
        dragEndHandler(e) {
            let draggedObject = this.orderedItems[e.newIndex];

            if (this.projectConfiguration.order == 'FORWARD') {
                if (e.newIndex > e.oldIndex) {
                    draggedObject.order = draggedObject.order + 1;
                } else {
                    draggedObject.order = draggedObject.order - 1;
                }
            } else {
                if (e.newIndex > e.oldIndex) {
                    draggedObject.order = draggedObject.order - 1;
                } else {
                    draggedObject.order = draggedObject.order;
                }
            }
            this.$store.dispatch('updateObject', {
                ...draggedObject,
            });
            this.recalculate();
        },
        recalculate() {
            this.macy.recalculate(true);
            // console.log('recalculate');
            document.getElementById('projectContainer').scrollTo(0, 0);
        },
        enableCreation() {
            this.$emit('create');
        },
        enableEdition(item) {
            return this.$emit('edit-object', item);
        },
        openModal(e) {
            this.$emit('add-element', e);
        },
        async updateOrCreateObject(clickSave) {
            if (
                !this.draft.location &&
                this.$store.getters.project.mode == 'map'
            ) {
                return confirm(this.$t('missing_location_message'));
            }
            /*console.log(
                'updating or creating',
                clickSave,
                window.getSelection().toString()
            );*/
            if (!clickSave) {
                let selObj = window.getSelection();
                if (selObj.toString().length > 0) {
                    return;
                }
            }
            if (this.draft._id == 'draft') {
                return this.$emit('create-object');
            } else {
                return this.$emit('update-object');
            }
        },
        async deleteObject(object_id) {
            return this.$emit('delete-object', object_id);
        },
        handleScroll() {
            const { scrollHeight, clientHeight, scrollTop } =
                document.documentElement;
            const bottomOfWindow =
                (scrollHeight - 300 >= clientHeight + scrollTop) /
                    scrollHeight ==
                0;
            if (bottomOfWindow && this.visibleItems < this.items.length) {
                this.visibleItems += 20;
            }
        },
        focusDraft() {
            this.$nextTick(() => {
                if (this.$refs.draft && this.$refs.draft.length) {
                    this.$refs.draft[0].scrollIntoView({
                        block: 'end',
                        inline: 'nearest',
                    });
                    document.getElementById('projectContainer').scrollTo(0, 0);
                }
            });
        },
        zoomImage(e){
            this.$emit('zoomImage',e);
        }
    },
};
</script>
